import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
} from "react";

import api from "@helpers/api.js";

import "./styles/chat-context.css";

import { useAuth } from "@contexts/AuthContext.js";

import * as Mui from "@mui/material";

import PersonIcon from "@mui/icons-material/Person";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DownloadIcon from "@mui/icons-material/Download";

import { ReactComponent as ExcelIcon } from "@assets/custom-icons/excel.svg";
import { ReactComponent as PDFIcon } from "@assets/custom-icons/pdf.svg";

import InfiniteScroll from "react-infinite-scroll-component";

import { Button } from "@fragments";
import { AddRounded } from "@mui/icons-material";

import UsersModal from "@components/Modals/UsersModal";

import Chat from '@components/Chat'
import Preview from '@components/Chat/components/Preview';

export default function ChatsBox({ children }) {
  const [loading, setLoading] = useState(true);

  const [chats, setChats] = useState([]);
  const [preview, setPreview] = useState();
  const [currentChat, setCurrentChat] = useState();

  const { user } = useAuth();

  const REF_lastChatsUpdate = useRef(Date.now());
  const REF_chatsUpdateSet = useRef(false);

  const REF_searchUsersModal = useRef();
  const REF_urlProcessed = useRef(false);

  useEffect(() => {
    if (loading || REF_urlProcessed.current) return;

    const params = new URLSearchParams(window.location.search);
    const chatUserId = params.get("chat");

    if (chatUserId) {
      const foundChat = chats.find((chat) => chat.user_id == chatUserId);
      if (foundChat) {
        startChatWith(foundChat);
      } else {
        startChatWith({
          user_id: chatUserId,
          username: "Usuário",
          email: "",
          avatar: "",
        });
      }
    }
    REF_urlProcessed.current = true;
  }, [loading, chats]);

  useEffect(() => {
    if (loading) {
      loadChats();
    }
  }, [loading]);

  useEffect(() => {
    if (REF_chatsUpdateSet.current) return;
    const interval = setInterval(() => {
      try {
        const now = Date.now();
        const updateTimeout = 30000;

        if (now - REF_lastChatsUpdate.current >= updateTimeout) {
          setLoading(true);
          REF_lastChatsUpdate.current = now;
        }
      } catch (e) {
        console.log(e);
      }
    }, 1000);
    REF_chatsUpdateSet.current = true;

    return () => clearInterval(interval); // Limpa o intervalo ao desmontar o componente
  }, []);

  useEffect(() => {
    const chatEventHandler = (e) => {
      startChatWith(e.detail);
    };
    window.addEventListener("start_chat_with", chatEventHandler);

    return () => {
      window.removeEventListener("start_chat_with", chatEventHandler);
    };
  }, []);

  function startChatWith(chatInfo) {
    setCurrentChat({ ...chatInfo });
  }

  async function loadChats() {
    setLoading(true);

    try {
      const { data } = await api.get("chat");
      if (JSON.stringify(data) !== JSON.stringify(chats)) setChats([...data]);
    } catch (e) {
      console.log(e);
    }

    setLoading(false);
  }

  function handleOpenPreview(imageUrl) {
    setPreview(imageUrl);
  }

  function handleSearchUsers() {
    REF_searchUsersModal.current.open(null, (user) => {
      console.log("User chosen", user);
      startChatWith({
        user_id: user.id,
        username: user.username,
        avatar: user.avatar,
        email: user.email,
      });
    });
  }

  const Memo_ChatList = useMemo(
    () => (
      <>
        {user && (
          <Chats
            chats={chats}
            startChatWith={startChatWith}
            handleSearchUsers={handleSearchUsers}
          />
        )}
      </>
    ),
    [user, chats]
  );
  const Memo_Chat = useMemo(
    () => (
      <Mui.Portal>
        {currentChat && (
          <Chat
            handleOpenPreview={handleOpenPreview}
            info={currentChat}
            onClose={() => setCurrentChat(null)}
          />
        )}
      </Mui.Portal>
    ),
    [currentChat]
  );

  return (
    <>
      <UsersModal modalRef={REF_searchUsersModal} />

      {Memo_ChatList}
      {Memo_Chat}

      {preview && (
        <Mui.Portal>
          <Preview image={preview} onClose={() => setPreview(null)} />
        </Mui.Portal>
      )}
    </>
  );
}

function sendMessageTo(userInfo) {
  userInfo.user_id = userInfo.id;
  userInfo.id = undefined; //Removido, pois o id no chat significa o id do chat, não do userId
  const event = new CustomEvent("start_chat_with", { detail: userInfo });
  window.dispatchEvent(event);
}

export { sendMessageTo };







function Chats({ chats = [], startChatWith, handleSearchUsers }) {
  function Chat({ info }) {
    return (
      <Mui.Button
        className={"chat-row  " + (info.unread_messages > 0 && "unread-chat")}
        onClick={() => startChatWith(info)}
        key={info.id}
      >
        <div>
          {info.avatar ? (
            <img className="chat-avatar" src={info.avatar} />
          ) : (
            <div className="chat-avatar">
              <PersonIcon />
            </div>
          )}
        </div>
        {info.unread_messages > 0 && (
          <div className="new-messages">
            <small className="nm-title">
              {info.unread_messages > 9 ? "+9" : info.unread_messages}
            </small>
          </div>
        )}
      </Mui.Button>
    );
  }
  return (
    <div className="chats chat-list-container">
      <Button
        icon={<AddRounded />}
        tooltip="Criar nova conversa"
        className="mb-1"
        color="overlay"
        size="small"
        style={{ "margin": "0 auto" }}
        onClick={handleSearchUsers}
      />

      {chats?.map((chat, i) => (
        <div key={i}>
          <Chat info={chat} key={i} />
          {i !== chats.length - 1 && <Mui.Divider className="mx-1" />}
        </div>
      ))}
    </div>
  );
}
